(ns minorodata.connections.sources.awin
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::bearer-token
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Auth token can't be empty"})))


(spec/def ::account-id
  (spec/and (st/spec string? {:reason "Please provide a publisher-id for the source"})
            (st/spec (complement c.string/blank?) {:reason "Publisher id can't be empty"})))


(spec/def ::awin-form
  (spec/and
   (spec/keys :req-un [::name ::bearer-token]
              :opt-un [::description])))


(def reports-for-advertisers
  [{:name "Transactions"  :value "transactions-list"}
   {:name "Reports aggregated by publisher"  :value "reports-aggregated-by-publisher"}])


(def reports-for-publishers
  [{:name "Transactions"  :value "transactions-list"}
   {:name "Reports aggregated by advertiser"  :value "reports-aggregated-by-advertiser"}
   {:name "Programmes"  :value "programmes"}])


(def source
  {:enabled      false
   :id           "awin"
   :name         "Awin (Deprecated)"
   :image-source "awin-connector-img.png"
   :description  "A global affiliate marketing network for advertisers and publishers"
   :tags         ["marketing"]


   :preview-formatter
   (fn []
     (str "Authenticated by token"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [bearer-token name description]} data]
        {:source-type "awin"
         :name        name
         :description description

         :source
         {:credentials {:bearer-token bearer-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:bearer-token]))))

    :validate (partial form-component/validate-form ::awin-form)

    :id :awin-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "OAuth2 Token"
              :name       :bearer-token
              :type       :password
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status
                 report account-type account-id action
                 destination-table relationship extract-type
                 backfill-months advanced-backfill-options
                 from-date to-date commission-status]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action                    action
                    :report                    report
                    :account-type              account-type
                    :extract-type              extract-type
                    :backfill-months           backfill-months
                    :commission-status         commission-status
                    :advanced-backfill-options advanced-backfill-options
                    :from-date                 from-date
                    :to-date                   to-date
                    :account-id                account-id
                    :destination-table         destination-table
                    :relationship              relationship}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :account-type :account-id :action
                               :relationship :extract-type :backfill-months :commission-status
                               :advanced-backfill-options :from-date :to-date])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :awin-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Account type"
              :name       :account-type
              :options    [{:name "Publisher"  :value "publishers"}
                           {:name "Advertiser" :value "advertisers"}]
              :required   true
              :value      "publishers"}

             {:block-type :input
              :label      "Account ID"
              :name       :account-id
              :required   true
              :value      ""}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    reports-for-publishers
              :required   true
              :value      "transactions-list"
              :conditions [[:eq [:account-type :value] "publishers"]]}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    reports-for-advertisers
              :required   true
              :value      "transactions-list"
              :conditions [[:eq [:account-type :value] "advertisers"]]}

             {:block-type :select
              :label      "Relationship"
              :name       :relationship
              :options    [{:name "All"        :value "all"}
                           {:name "Joined"     :value "joined"}
                           {:name "Pending"    :value "pending"}
                           {:name "Suspended"  :value "suspended"}
                           {:name "Rejected"   :value "rejected"}
                           {:name "Not joined" :value "notjoined"}]
              :value      "all"
              :conditions [[:eq [:report :value] "programmes"]]}

             {:block-type :select
              :label      "Commission Status"
              :name       :commission-status
              :options    [{:name "Pending"   :value "pending"}
                           {:name "Approved"   :value "approved"}
                           {:name "Declined"   :value "declined"}
                           {:name "Deleted"   :value "deleted"}]
              :value      ""
              :required    false
              :conditions [[:and [[:account-type :value] [:report :value]] ["advertisers" "transactions-list"]]]}

             {:block-type :select
              :label      "Initial Backfill"
              :name       :backfill-months
              :options    [{:name "1 Month"  :value 1}
                           {:name "2 Months" :value 2}
                           {:name "3 Months" :value 3}
                           {:name "6 Months" :value 6}
                           {:name "1 Year"   :value 12}
                           {:name "2 Years"  :value 24}
                           {:name "3 Years"  :value 36}]
              :required   true
              :doc        [:span "Large backfills can cause extracts to take a long time or fail"]
              :value      24
              :conditions [[:eq [:report :value] "transactions-list"]
                           [:eq [:report :value] "reports-aggregated-by-publisher"]
                           [:eq [:report :value] "reports-aggregated-by-advertiser"]]}

             {:block-type :checkbox
              :label      "Advanced backfill options"
              :name       :advanced-backfill-options
              :type       :checkbox
              :value      false
              :conditions [[:eq [:report :value] "transactions-list"]
                           [:eq [:report :value] "reports-aggregated-by-publisher"]
                           [:eq [:report :value] "reports-aggregated-by-advertiser"]]}

             {:block-type :date-picker
              :label      "From date"
              :name       :from-date
              :required   false
              :conditions [[:eq [:advanced-backfill-options :value] true]]}

             {:block-type :date-picker
              :label      "To date"
              :name       :to-date
              :required   false
              :conditions [[:eq [:advanced-backfill-options :value] true]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "append"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
